var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEthStaking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 303,
    height: 164,
    viewBox: "0 0 303 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16345 7.16344 0 16 0H287C295.837 0 303 7.16344 303 16V148C303 156.837 295.837 164 287 164H16C7.16345 164 0 156.837 0 148V16Z",
    fill: "#73A2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.5 38L126.5 54L31.5 54L31.5 38L126.5 38Z",
    fill: "#CED2DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.5 110L126.5 126L31.5 126L31.5 110L126.5 110Z",
    fill: "#CED2DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M196.5 70L196.5 94L31.5 94L31.5 70L196.5 70Z",
    fill: "#CED2DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M219.5 134C190.781 134 167.5 110.719 167.5 82C167.5 53.2812 190.781 30 219.5 30C248.219 30 271.5 53.2812 271.5 82C271.5 110.719 248.219 134 219.5 134Z",
    fill: "#FFD200"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.5 82C262.5 58.2518 243.248 39 219.5 39C195.752 39 176.5 58.2518 176.5 82C176.5 105.748 195.752 125 219.5 125C243.248 125 262.5 105.748 262.5 82ZM219.5 37C244.353 37 264.5 57.1472 264.5 82C264.5 106.853 244.353 127 219.5 127C194.647 127 174.5 106.853 174.5 82C174.5 57.1472 194.647 37 219.5 37Z",
    fill: "#0A0B0D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M143.5 70C130.245 70 119.5 59.2548 119.5 46C119.5 32.7452 130.245 22 143.5 22C156.755 22 167.5 32.7452 167.5 46C167.5 59.2548 156.755 70 143.5 70Z",
    fill: "#5DE2F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M159.965 45.9729C151.027 43.2162 145.758 34.2973 143.5 23C141.242 34.2973 135.973 43.2162 127.035 45.9729C126.988 45.9729 126.988 46.0271 127.035 46.0271C135.973 48.7838 141.242 57.7027 143.5 69C145.758 57.7027 151.027 48.7838 159.965 46.0271C160.012 46.0271 160.012 45.9729 159.965 45.9729Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M135.5 117.5C135.5 130.479 124.755 141 111.5 141C98.2452 141 87.5 130.479 87.5 117.5C87.5 104.521 98.2452 94 111.5 94C124.755 94 135.5 104.521 135.5 117.5Z",
    fill: "#00D17F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M119.5 118L111.484 126L103.5 118L111.485 110L119.5 118Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M131.499 118C131.499 111.371 136.871 106.001 143.5 106.001C136.871 106.001 131.499 100.629 131.499 94C131.499 100.629 126.126 106.001 119.5 106.001C126.126 106.001 131.499 111.371 131.499 118Z",
    fill: "#FFD200"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M163.501 46C163.501 39.3715 158.129 34.0012 151.5 34.0012C158.129 34.0012 163.501 28.6285 163.501 22C163.501 28.6285 168.874 34.0012 175.5 34.0012C168.874 34.0012 163.501 39.3715 163.501 46Z",
    fill: "#00D17F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M166.255 38.3506C165.128 34.9971 163.281 31.9745 160.897 29.4668C158.698 32.2302 155.306 34.0015 151.5 34.0015C158.129 34.0015 163.501 39.3718 163.501 46.0003C163.501 43.0926 164.535 40.427 166.255 38.3506Z",
    fill: "#0052FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M134.336 110.25C132.566 112.34 131.499 115.045 131.499 117.999C131.499 111.371 126.126 106.001 119.5 106.001C123.344 106.001 126.767 104.192 128.963 101.379C131.373 103.881 133.228 106.901 134.336 110.25Z",
    fill: "#0052FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232 82.0128C231.996 82.3023 231.867 82.576 231.647 82.7632L208.647 102.263L207.353 100.738L228.274 83.0004L31.5 83.0004L31.5 81.0004L228.375 81.0004L207.335 62.2469L208.665 60.7539L231.665 81.2539C231.881 81.4465 232.004 81.7233 232 82.0128Z",
    fill: "#0A0B0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthStaking);
export default __webpack_public_path__ + "static/media/EthStaking.ab218282e2e915a415627dfec13a12f5.svg";
export { ForwardRef as ReactComponent };